/*global eclipseApp, console, angular*/
(function () {

  'use strict';

  var __brtPeriod;          //updated when application starts, check NOTE1
  var __brtSession;         //updated with http response, check NOTE2
  var __byPassRecpatcha;
  var __brtUnwired; //CH-4586 Updated when app is load

  var __devBrtPeriod;       //This is for development only, and should only be used by devXXXX function
  var __devBrtSession;      //This is for development only, and should only be used by devXXXX function

  var __initialBRTCallsInProgress;

  console.debug('BRT: __brtPeriod/__brtSession starts as', __brtPeriod, __brtSession);
  /**
   *  This is a provider because it's used by ui-router config. and config cannot use a service, but a provider
   */
  angular.module('eclipseApp.brt')
    .provider('brt', function brtProvider() {

      var self = this;
      this.isBRTPeriod= function() {
        return typeof __devBrtPeriod !== 'undefined' ? __devBrtPeriod: __brtPeriod;
      };
      this.isBRTUnwired = function () { //CH-4586
        return typeof __devBrtUnwired !== 'undefined' ? __devBrtPeriod : __brtUnwired;
      };
      this.isBRTSession= function() {
        return typeof __devBrtSession !== 'undefined' ? __devBrtSession: __brtSession;
      };
      this.isByPassRecaptcha= function() {
        return typeof __byPassRecpatcha !== 'undefined' ? __byPassRecpatcha: false;
      }
      this.isBRTTest= function() {
        return this.isBRTPeriod() && this.isBRTSession() && this.isBRTUnwired(); //CH-4586
      };

      //returns old template url only if brt period with no brt session
      this.getTemplateProvider = function(url) {
        return ['$templateCache', 'brt', function($templateCache, brt) {
          return brt.getBRTPeriod().then(function(results) {
            var oldTemplateUrl = url.replace(/modules\/([^\/]+)/, function($0, moduleName) {
              return 'modules/' + 'old-' + moduleName;
            });
            var templateUrl = self.isBRTPeriod() && !self.isBRTSession() ? oldTemplateUrl : url;
            console.debug('BRT: brtProvider.getTemplateUrl', self.isBRTPeriod(), self.isBRTSession(), templateUrl);
            var template = $templateCache.get(templateUrl) || $templateCache.get(url);
            return  template;
          });
        }];
      };

      //returns old controller name only if brt period with no brt session
      // this only can return string or a function, http://stackoverflow.com/questions/30259668/controllerprovider-in-ui-router-results-in-error
      this.getControllerProvider = function(ctrlStr) {
        return function() {
          var controllerStr = ctrlStr;
          if (self.isBRTPeriod() && !self.isBRTSession()) {
            var oldCtrlStr = _.camelCase('old-' + ctrlStr);
            if (eclipseApp.brtControllers.indexOf(oldCtrlStr) !== -1) {
              controllerStr = oldCtrlStr;
            }
          }
          console.debug('BRT: brtProvider.controllerStr', self.isBRTPeriod(), self.isBRTSession(), controllerStr);
          return controllerStr ;
        };
      };

      this.$get = ['$rootScope', '$http', '$q', '$timeout', 'uteEndpoint', 'env', '$templateCache', 'notifier', function($rootScope, $http, $q, $timeout, uteEndpoint, env, $templateCache, notifier) {

        var getBRTPeriod = function() {
          var deferred = $q.defer();

          // variables are undefined because no initial BRT calls has been made
          if (typeof __brtPeriod === 'undefined' || typeof __brtSession === 'undefined' || typeof __byPassRecpatcha === 'undefined') {
            if (__initialBRTCallsInProgress) {
              console.debug('BRT: Initial BRT Calls are in progress. Waiting');
              var retryLimit = 10;
              var waitUntilInitialBRTCallsMade = function () {
                if (retryLimit > 0) {
                  if (__initialBRTCallsInProgress) {
                    console.log('BRT: ...................waiting', retryLimit);
                    retryLimit--;
                    $timeout(waitUntilInitialBRTCallsMade, 500);
                  } else {
                    console.debug('BRT: Initial BRT Calls are done. Returning', [__initialBRTCallsInProgress, __brtPeriod, __brtSession]);
                    deferred.resolve([self.isBRTPeriod(), self.isBRTSession()]);
                  }
                } else  {
                  notifier.notify.error();
                  throw "ERROR: BRT Status check failed";
                }
              };
              waitUntilInitialBRTCallsMade();
            } else {
              var brtSwitchesUrl = uteEndpoint('v1/brtswitches');
              var checkBrtUrl = uteEndpoint('v1/checkbrt');

              __initialBRTCallsInProgress = true;
              console.debug('BRT: Getting BRT period/session from', brtSwitchesUrl, checkBrtUrl);
              notifier.notify.processing();
              $q.all([
                $http.get(brtSwitchesUrl),
                $http.get(checkBrtUrl)
              ]).then(function (results) {

                // ............. Setting BRT Period .................
                __brtPeriod = false;
                __brtUnwired = false; //CH-4586
                //Added to bypass recaptch :: Start
                var recaptchaHeader = results[0].headers("Recaptcha-ByPass-Flag");
                __byPassRecpatcha = recaptchaHeader && (recaptchaHeader == true || recaptchaHeader == "true");
                //Bypass recaptcha changes :: End

                console.log('isByPassRecaptcha', results[0].headers("Recaptcha-ByPass-Flag"));
                for (var i=0; i< results[0].data['brtSwitchDetails'].length; i++) {
                  var el = results[0].data['brtSwitchDetails'][i];
                  if (el['switchName'] === 'BRTSWITCH') {
                    __brtPeriod = el.enabled;
                    //break;
                  }
                  if (el['switchName'] === 'DISABLE_TI') { //CH-4586
                    __brtUnwired = el.enabled;
                    
                  }
                }
                console.debug('BRT: Setting BRT period from',  __brtPeriod, results[0]);
                console.log('BRT: Setting BRT period from', __brtPeriod, results[0]);
                console.log('BRT: Unwired', __brtUnwired, results[0]); //CH-4586
                // ............. Setting BRT Session .................
                __brtSession = false;
                __brtSession = results[1].data['brtSession'];
                console.debug('BRT: Setting BRT session from',  __brtSession, results[1]);

                __initialBRTCallsInProgress = false;
                notifier.notify.done();
                deferred.resolve([self.isBRTPeriod(), self.isBRTSession(), self.isBRTUnwired()]); //CH-4586
              }, function(error) {
                   console.debug('BRT: Error on BRT calls', error);
                   __brtPeriod = false;
                   __brtSession = false;
                   __byPassRecpatcha = false;
                  __brtUnwired = false; //CH-4586
                   deferred.reject(error);
                   notifier.notify.error();
                   throw error;

                 })/*.error(function(error) {
                console.debug('BRT: Error on BRT calls', error);
                __brtPeriod = false;
                __brtSession = false;
                deferred.reject(error);
                notifier.notify.error();
                throw error;

              })*/.catch(function(error){
                console.debug('BRT: CATCH Error on BRT calls', error);
                notifier.notify.error();
                throw error;
              });
            }
          } else {
            //return the previously set result, so that we don't make extra calls
            deferred.resolve([self.isBRTPeriod(), self.isBRTSession(), self.isBRTUnwired()]); //CH-4586
          }

          return deferred.promise;
        };


        /**
         * commented out because of  unstable header status(not present mainly)
         * If header is not present, it's overriding BRT session value
         */
        // var setBRTSession = function(response) {
        //   if (response.headers("IsBrtSession")) {
        //     var newBRTSession   = !!response.headers("IsBrtSession");
        //     if (__brtSession !== newBRTSession) {
        //       __brtSession = newBRTSession;
        //       console.debug("BRT: Setting new BRT Session", __brtSession);
        //     }
        //   } else {
        //     if ( !__initialBRTCallsInProgress && __brtSession !== false) {
        //       // console.debug("BRT: No IsBRTSession Header found, setting brtSession as ", false);
        //       // __brtSession = false;
        //     }
        //   }
        // };

        //This is only for local development,
        //it's also safe for production because this won't be executed unless it's local environment
        var devBRT = function(key) {
          if (env.name === 'local') {
            (key === 'period') && (__devBrtPeriod = !!!__devBrtPeriod);
            (key == 'session') && (__devBrtSession = !!!__devBrtSession);
            (key === 'unwired') && (__devBrtUnwired = !!!__devBrtUnwired); //CH-4586
          }
        };

        //This is only for local development and it is safe for production because
        // 1. this won't be executed unless it's local environment
        // 2. there is no /resource/userInfo.json in production
        var loginAsMockUser = function() {
          var url = uteEndpoint('/resource/userInfo.json');
          $http.get(url).success(function(resp) {
            $rootScope.userInfo = {
              "uuid": "c2d8ad99-6698-4dd1-8952-bc15b79f3d0f",
              "firstName": "JHB",
              "lastName": "UHVGJ",
              "lowerFirstName": "jhb",
              "accounts": [{
                  "accountNumber": "836498733",
                  "status": "OPEN",
                  "reasonCode": null,
                  "serviceName": "Wireless",
                  "delinquentStatus": null,
                  "contactId": "CO2101005249",
                  "fidoGuid": null,
                  "accountOrder": "1",
                  "$$hashKey": "object:358",
                  "serviceNameLabel": "Mobile"
                }
              ],
              "profileType": {
                "groupId": false,
                "owner": true,
                "ctn": false,
                "prepaid": false,
                "subscriber": false
              },
              "selectedAccountNumber": "836498733",
              "selectedSubscriberNo": ""
            };
            $rootScope.userInfo.uuid = 'c2d8ad99-6698-4dd1-8952-bc15b79f3d0';
          });
        };


        // Introduced getTemplate for service & controller level usage where a template path is required to render a view
        var getTemplate = function (url) {

          var oldTemplateUrl = url.replace(/(\w)\/([^\/]+)/, function($0, baseDirName, dirName) {
            return baseDirName +  '/old-' + dirName;
          });

          var templateUrl = self.isBRTPeriod() && !self.isBRTSession() ? oldTemplateUrl : url;
          var template = $templateCache.get(templateUrl) ? templateUrl : url;

          return template;
        };

        var getController = function (ctrlStr) {
          console.log('#brt/getController ',self.getControllerProvider(ctrlStr));
          return self.getControllerProvider(ctrlStr)();
        };

        return {
          isBRTPeriod: self.isBRTPeriod,
          isBRTSession: self.isBRTSession,
          isByPassRecaptcha: self.isByPassRecaptcha,
          isBRTTest: self.isBRTTest,
          isBRTUnwired: self.isBRTUnwired, //CH-4586
          getBRTPeriod: getBRTPeriod,
          devBRT: devBRT,
          loginAsMockUser: loginAsMockUser,
          getTemplate: getTemplate,
          getController: getController
        };
      }];

    });

})();
